import { Button, Grid, Group, Paper, Stack } from "@mantine/core";
import React, { useEffect, useState } from "react";
import { Service } from "../components/service";
import { CREATE_PLAN, GET_ALL_PLANS, DELETE_PLAN, UPDATE_PLAN } from "../services/plans";
import InputField, { InputFieldMasks, InputFieldTypes } from "../components/input_field";
import { notifications, showNotification } from "@mantine/notifications";
import { useApp } from "../contexts/app.context";
import { GET_ALL_VEHICLES_CATEGORIES } from "../services/vehicles_categories";

export default function PlansPage() {
    const [plans, setPlans] = useState<any[]>([]);
    const [selectedPlan, setSelectedPlan] = useState<any>(null);
    const [loadingSave, setLoadingSave] = useState<boolean>(false);
    const [categories, setCategories] = useState<any[]>([]);

    const { confirmDialog } = useApp();

    const loadPlans = () => {
        GET_ALL_PLANS()
            .then(res => {
                setPlans(res);
            })
            .catch(err => {
                notifications.show({ message: err.message, color: "red" })
            })
    }

    const handleSave = () => {
        const plan = selectedPlan;
        if (!plan._id) {
            setLoadingSave(true);
            CREATE_PLAN(plan)
                .then(res => {
                    loadPlans();
                    setSelectedPlan(res);
                })
                .catch(err => { showNotification({ message: err.message, color: "red" }) })
                .finally(() => { setLoadingSave(false); })
        } else {
            setLoadingSave(true);
            let params = { ...plan };
            delete params._id;
            UPDATE_PLAN(plan._id, params)
                .then(res => {
                    loadPlans();
                    showNotification({ message: "Plano atualizado", color: "green" })
                })
                .catch(err => { showNotification({ message: err.message, color: "red" }) })
                .finally(() => { setLoadingSave(false); })
        }
    }

    const loadCategories = async () => {
        try {
            setCategories(await GET_ALL_VEHICLES_CATEGORIES());
        } catch (err: any) {
            showNotification({ message: err.message, color: "red" })
        } finally {

        }
    }

    useEffect(() => {
        loadCategories()
        loadPlans()
    }, [])

    return <div style={{ position: 'relative' }}>
        <Grid>
            <Grid.Col span={{ base: 12, md: 12 }}>
                <Paper p="md" mb="md">
                    <Group>
                        <div style={{ flex: 1 }}>
                            <InputField
                                name="pl"
                                onChange={({ pl }: any) => {
                                    pl === "new"
                                        ? setSelectedPlan({})
                                        : setSelectedPlan(plans.find(p => p._id === pl))
                                }}
                                value={selectedPlan ? selectedPlan?._id || "new" : null}
                                fieldType={InputFieldTypes.SELECT}
                                clearable={false}
                                searchable={false}
                                options={[
                                    ...plans.map(p => ({ label: p.title, value: p._id })),
                                    { value: "new", label: "Novo Plano" }
                                ]}
                            />
                        </div>
                        {selectedPlan?._id && <Button color="red" variant="outline"
                            onClick={() => {
                                confirmDialog(
                                    { text: "Do you realy wants to delete this plan?" },
                                    ({ confirmed }) => {
                                        if (confirmed) DELETE_PLAN(selectedPlan?._id)
                                            .then(() => {
                                                loadPlans();
                                                setSelectedPlan(null);
                                            })
                                            .catch(err => {
                                                notifications.show({ message: err.message })
                                            })
                                    }
                                )
                            }}
                        >Deletar plano</Button>}
                    </Group>
                </Paper>

                {selectedPlan && <>
                    <Paper p="md" mb="md">
                        <Stack>

                            <Group>
                                <InputField
                                    name="safe_price"
                                    mask={InputFieldMasks.MONEY}
                                    onChange={({ safe_price }: any) => setSelectedPlan((sp: any) => ({ ...sp, safe_price }))}
                                    value={selectedPlan?.safe_price}
                                    title="Cauçao"
                                    style={{ flex: 1 }}
                                />
                                <InputField
                                    name="price"
                                    mask={InputFieldMasks.MONEY}
                                    onChange={({ price }: any) => setSelectedPlan((sp: any) => ({ ...sp, price }))}
                                    value={selectedPlan?.price}
                                    title="Valor Unitário"
                                    style={{ flex: 1 }}
                                />

                                <InputField
                                    name="recurrence_type"
                                    title="Tipo de Recorrência"
                                    value={selectedPlan?.recurrence_type ?? "month"}
                                    fieldType={InputFieldTypes.SELECT}
                                    placeholder='Period'
                                    searchable={false}
                                    clearable={false}
                                    style={{ flex: 1 }}
                                    onChange={({ recurrence_type }: any) => { setSelectedPlan((sp: any) => ({ ...sp, recurrence_type })) }}
                                    options={[
                                        { value: "month", label: "Mensal" },
                                        { value: "week", label: "Semanal" },
                                        { value: "year", label: "Anual" },
                                    ]}
                                />
                            </Group>
                            <Group>
                                <InputField
                                    name="max_distance"
                                    fieldType={InputFieldTypes.NUMBER}
                                    onChange={({ max_distance }: any) => setSelectedPlan((sp: any) => ({ ...sp, max_distance }))}
                                    value={selectedPlan?.max_distance}
                                    title="Distância Máxima (km)"
                                    style={{ flex: 1 }}
                                />
                                <InputField
                                    name="add_on_distance"
                                    mask={InputFieldMasks.MONEY}
                                    onChange={({ add_on_distance }: any) => setSelectedPlan((sp: any) => ({ ...sp, add_on_distance }))}
                                    value={selectedPlan?.add_on_distance}
                                    title="Custo Adicional de Distância (por km)"
                                    style={{ flex: 1 }}
                                />
                            </Group>
                            <Group>
                                <InputField
                                    name="fidelity_period"
                                    fieldType={InputFieldTypes.NUMBER}
                                    onChange={({ fidelity_period }: any) => setSelectedPlan((sp: any) => ({ ...sp, fidelity_period }))}
                                    value={selectedPlan?.fidelity_period}
                                    title="Período da Fidelidade"
                                    style={{ flex: 1 }}
                                />
                                <InputField
                                    name="fidelity_type"
                                    fieldType={InputFieldTypes.SELECT}
                                    onChange={({ fidelity_type }: any) => setSelectedPlan((sp: any) => ({ ...sp, fidelity_type }))}
                                    value={selectedPlan?.fidelity_type}
                                    title="Tipo de Fidelidade"
                                    style={{ flex: 1 }}
                                    options={[
                                        { value: "month", label: "Mensal" },
                                        { value: "week", label: "Semanal" },
                                        { value: "year", label: "Anual" },
                                    ]}
                                />
                            </Group>
                            {/* <InputField
                            name="exceed_price"
                            mt="md"
                            mask={InputFieldMasks.MONEY}
                            onChange={({exceed_price}) => setSelectedPlan((sp: any) => ({...sp, exceed_price}))}
                            value={selectedPlan?.exceed_price}
                            title="Exceed Price"
                        /> */}
                        </Stack>
                    </Paper>
                    <Paper p="md">
                        <Stack>
                            <InputField
                                name="categories"
                                fieldType={InputFieldTypes.SELECT}
                                options={categories.map(c => ({ label: c.title, value: c._id }))}
                                multiple
                                onChange={({ categories }: any) => setSelectedPlan((sp: any) => ({ ...sp, categories }))}
                                value={selectedPlan?.categories ?? []}
                                title="Categorias"
                                style={{ maxWidth: 100 }}
                            />
                            <InputField
                                name="title"
                                onChange={({ title }: any) => setSelectedPlan((sp: any) => ({ ...sp, title }))}
                                value={selectedPlan?.title}
                                title="Nome do Plano"
                            />
                            <InputField
                                name="description"
                                fieldType={InputFieldTypes.TEXTAREA}
                                onChange={({ description }: any) => setSelectedPlan((sp: any) => ({ ...sp, description }))}
                                value={selectedPlan?.description}
                                title="Descrição"
                            />
                        </Stack>
                    </Paper>
                    <Button mt="md" loading={loadingSave} onClick={handleSave}>Salvar</Button>
                </>}
            </Grid.Col>
        </Grid>
    </div>
}
